import { FieldLabel, Tooltip, TooltipContent, TooltipTrigger } from "@pdfking/components"
import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { CircleHelpIcon } from "lucide-react"

import { useTranslation } from "../../i18n/useTranslation"

export const DjLabel = CreateRenderFunction({
  props: {
    field_id: "",
    path: "",
  },
  render() {
    const labels = useTranslation("form_label")
    const help = useTranslation("form_help")[this.field_id]
    return (
      <FieldLabel
        className="w-full gap-1 text-[10px] font-semibold uppercase text-foreground"
        htmlFor={this.path}
      >
        {labels[this.field_id]?.() ?? this.field_id}
        {help && (
          <Tooltip>
            <TooltipTrigger asChild>
              <CircleHelpIcon className="size-3 text-muted-foreground" />
            </TooltipTrigger>
            <TooltipContent side="top">{help()}</TooltipContent>
          </Tooltip>
        )}
      </FieldLabel>
    )
  },
})
